import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import Translate from "../../components/Translate";
import {useHistory} from "react-router-dom";
import {deleteClasseTipoImpExpDatiApi, getClassiTipiImpExpDatiApi} from "./services/TipiImpExpDatiServices";
import TabellaClassiTipiImpExpDatiController from "./components/TabellaClassiTipiImpExpDatiController";
import ConfClassiTipiImpExpView from "./ConfClassiTipiImpExpView";
import ConfStrutturaClassiImpExpController from "./components/ConfStrutturaClassiImpExpController";
import ConfTipoImpExpDatiController from "./components/ConfTipoImpExpDatiController";

export default function ConfClassiTipiImpExpController() {

    const [loadingData, setLoadingData] = useState(true);

    const [classiImpExp, setClassiImpExp] = useState([]);
    const [classeSel, setClasseSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [keyTab, setKeyTab] = useState(0);

    const [showDettagli, setShowDettagli] = useState(false);
    const [elementoDettagli, setElementoDettagli] = useState();

    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getClassiTipiImpExpDati() {
        const response = await getClassiTipiImpExpDatiApi();
        setClassiImpExp(response.data.data);
        setLoadingData(false);
    }

    function setValoriInfo(qualeinfo) {
        let elemento =[];
        if (qualeinfo == 'C') {
            elemento.titolo_dettaglio = translate('titolo classi');
            elemento.testo_dettaglio = translate('testo classi org');
        } else if (qualeinfo == 'S') {
            elemento.titolo_dettaglio = translate('titolo struttura');
            elemento.testo_dettaglio = translate('testo struttura org');
        } else if (qualeinfo == 'E') {
            elemento.titolo_dettaglio = translate('titolo elementi');
            elemento.testo_dettaglio = translate('testo elementi org');
        }
        setElementoDettagli(elemento);
    }

    useEffect(() => {
        getClassiTipiImpExpDati();
    }, []);

    const eliminaClasse = async () => {
        setShowConfirm(false);
        const response = await deleteClasseTipoImpExpDatiApi(classeSel.id_classe_tipo_imp_exp);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setClassiImpExp(response.data.data);
        }
    }

    function getIconaDettaglio(quale, elemento) {
        return (
            <i
                className="fas fa-info-circle ns-mouse-pointer ps-2"
                style={{
                    fontSize: "1.2rem"
                }}
                onClick={() => {
                    setValoriInfo(quale);
                    setShowDettagli(true);
                }}
            />
        );
    }
    const scrollableTabs = [
        {
            title: <React.Fragment><Translate>Classi</Translate> &nbsp;
                {getIconaDettaglio('C', elementoDettagli)}
            </React.Fragment>,
            content: <TabellaClassiTipiImpExpDatiController
                translate={translate}
                setShowConfirm={setShowConfirm}
                history={history}
                classiImpExp={classiImpExp}
                setClasseSel={setClasseSel}
            />
        },
        {
            title: <React.Fragment><Translate>Struttura</Translate> &nbsp;
                {getIconaDettaglio('S', elementoDettagli)}
            </React.Fragment>,
            content: <ConfStrutturaClassiImpExpController/>
        },
        {
            title: <React.Fragment><Translate>Elementi</Translate> &nbsp;
                {getIconaDettaglio('E', elementoDettagli)}
            </React.Fragment>,
            content: <ConfTipoImpExpDatiController/>
        }
    ];

    const bottoniDx = [
        keyTab === 0 && {
            label: translate("Aggiungi"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-classe-imp-exp");
            }
        },
        keyTab === 1 && {
            label: translate("Aggiungi Struttura"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-struttura-classe-imp-exp");
            }
        },
        keyTab === 2 && {
            label: translate("Aggiungi"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-tipo-imp-exp");
            }
        }
    ];

    return (
        <ConfClassiTipiImpExpView
            eliminaClasse={eliminaClasse}
            setShowConfirm={setShowConfirm}
            history={history}
            translate={translate}
            show={show}
            showConfirm={showConfirm}
            modalMsg={modalMsg}
            keyTab={keyTab}
            scrollableTabs={scrollableTabs}
            setShow={setShow}
            loadingData={loadingData}
            classeSel={classeSel}
            setKeyTab={setKeyTab}
            bottoniDx={bottoniDx}
            elementoDettagli={elementoDettagli}
            showDettagli={showDettagli}
            setShowDettagli={setShowDettagli}
        />
    );
}
